/**
 * @generated SignedSource<<8d568f1933fda2eccf3ef02806db467f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeleteSubGroupButtonFragment$data = {
  readonly id: string;
  readonly name: string;
  readonly parentMemberGroupId: string | null;
  readonly productId: string | null;
  readonly " $fragmentType": "DeleteSubGroupButtonFragment";
};
export type DeleteSubGroupButtonFragment$key = {
  readonly " $data"?: DeleteSubGroupButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteSubGroupButtonFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeleteSubGroupButtonFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "productId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentMemberGroupId",
      "storageKey": null
    }
  ],
  "type": "MemberGroup",
  "abstractKey": null
};

(node as any).hash = "5df9e8f009a6009cd08ca1941a01bdfe";

export default node;
